<template>
	<cm-lightbox v-if="lightboxObjectVisible" @lgbcancel="onCancel">
		<template v-slot:header>{{ lightbox?.header }}</template>

		<template v-slot:body>
			<div class="lightbox__block">
				<div class="lightbox__title">{{ preface.title }}</div>
				<cm-dropdown
					:type="preface.dropdown.type"
					:name="preface.name"
					:items="preface.dropdown.categories"
					:value="preface.dropdown.value"
					:status="preface.dropdown.status"
					:system="preface.dropdown.system"
					:disabled="preface.dropdown.disabled"
					@click="onChange($event, 'dropdown')"
				/>
			</div>

			<template v-if="type">
				<div class="lightbox__block" v-for="(block, index) in lightbox.body" :key="index">
					<template v-if="block.kind === 'single'">
						<div class="lightbox__title">{{ block.title }}</div>
						<cm-dropdown
							:type="block.dropdown.type"
							:name="block.name"
							:items="block.dropdown.categories"
							:value="block.dropdown.value"
							:status="block.dropdown.status"
							:disabled="block.dropdown.disabled"
							:system="block.dropdown.system"
							v-if="block.dropdown"
							@click="onChange($event, 'dropdown')"
						/>
						<cm-input
							:type="'text'"
							:name="block.name"
							:value="block.value"
							:status="block.status"
							:disabled="block.disabled"
							v-else
							@input="onChange($event, 'input')"
							@paste="onChange($event, 'input')"
							@change="onChange($event, 'input')"
							@blur="onChange($event, 'input')"
						/>
					</template>
					<template v-if="block.kind === 'double'">
						<div class="lightbox__subblock" data-part="first">
							<div class="lightbox__title">{{ block.first.title }}</div>
							<cm-input
								:type="'text'"
								:name="block.first.name"
								:value="block.first.value"
								:status="block.first.status"
								:disabled="block.first.disabled"
								@input="onChange($event, 'input')"
								@paste="onChange($event, 'input')"
								@change="onChange($event, 'input')"
								@blur="onChange($event, 'input')"
							/>
						</div>
						<div class="lightbox__subblock" data-part="last">
							<div class="lightbox__title">{{ block.last.title }}</div>
							<cm-input
								:type="'text'"
								:name="block.last.name"
								:value="block.last.value"
								:status="block.last.status"
								:disabled="block.last.disabled"
								@input="onChange($event, 'input')"
								@paste="onChange($event, 'input')"
								@change="onChange($event, 'input')"
								@blur="onChange($event, 'input')"
							/>
						</div>
					</template>
				</div>
			</template>

			<div class="lightbox__preloader" v-if="loading">Loading ...</div>
		</template>

		<template v-slot:footer>
			<cm-button type="text" value="Создать объект" paint="blue" :disabled="!validation" @click="onApply" />
		</template>
	</cm-lightbox>
</template>

<script>
	import axios from "axios";
	import { mapGetters, mapMutations, mapActions } from "vuex";

	import Lightbox from "../appearance/Lightbox.vue";
	import Button from "../components/Button.vue";
	import Dropdown from "../components/Dropdown.vue";
	import Input from "../components/Input.vue";

	export default {
		components: {
			"cm-button": Button,
			"cm-dropdown": Dropdown,
			"cm-input": Input,
			"cm-lightbox": Lightbox,
		},
		data() {
			return {
				loading: false,
				lightbox: null,
				preface: null,
				type: null,
				cities: [],
				streets: [],
				fields: {
					type: null,
					name: null,
					dealer: null,
					region: null,
					city: null,
					street: null,
					home: null,
					apartment: null,
					pro_system_id: null,
					comment: null,
				},
				validation: false,
			};
		},
		computed: {
			...mapGetters({
				lightboxObjectVisible: "lightboxObjectVisible",
				regions: "getSystemsRegions",
				dealers: "getSystemsDealers",
				proSystems: "getSystemsProSystems",
			}),
			state() {
				return this.$store.state;
			},
		},
		methods: {
			...mapMutations(["showLightboxObject"]),
			...mapActions(["newCreateSystemsObject"]),

			/* INIT FUNCTIONS */
			init(context) {
				if (!context) return;

				this.initLightbox();

				setTimeout(() => {
					if (context.type && context.pro_system_id) {
						this.type = context.type;

						this.preface.dropdown.value = "Локальная";
						this.preface.dropdown.status = "valid";
						this.preface.dropdown.disabled = true;

						this.fields.type = context.type;

						this.initLightboxBody();

						let proSystemBlock = this.lightbox.body.find((item) => item.name == "pro_system_id");

						if (proSystemBlock) {
							let proSystem = this.proSystems.find((item) => item.id == context.pro_system_id);

							if (proSystem) {
								//proSystemBlock.dropdown.name = proSystem.value;
								proSystemBlock.dropdown.value = proSystem.title;
								proSystemBlock.dropdown.status = "valid";
								proSystemBlock.dropdown.disabled = true;

								this.fields.pro_system_id = proSystem.id;
							}
						}
					}
				}, 100);
			},
			initLightbox() {
				this.lightbox = {
					header: "Создание объекта",
				};

				this.preface = {
					id: 0,
					kind: "set",
					name: "type",
					title: "Тип объекта",
					value: "",
					dropdown: {
						type: "simple",
						name: "",
						value: "",
						status: "default",
						disabled: false,
						error: false,
						errorMessage: "Неверный формат",
						categories: [
							{
								id: 0,
								name: "home",
								title: "Индивидуальная",
							},
							{
								id: 1,
								name: "pro",
								title: "Централизованная",
							},
							{
								id: 2,
								name: "pro_home",
								title: "Локальная",
							},
						],
					},
				};
			},
			initLightboxBody() {
				if (this.type == "home" || this.type == "pro") {
					this.lightbox.body = [
						{
							kind: "single",
							type: "input",
							name: "name",
							title: "Название объекта",
							value: "",
							status: "default",
							error: false,
							errorMessage: "Неверный формат",
						},
						{
							kind: "single",
							type: "dropdown",
							name: "dealer",
							title: "Дилер",
							value: "",
							dropdown: {
								type: "simple",
								name: "",
								value: "",
								status: "default",
								error: false,
								errorMessage: "Неверный формат",
								categories: this.dealers,
							},
						},
						{
							kind: "single",
							type: "dropdown",
							name: "region",
							title: "Регион",
							value: "",
							dropdown: {
								type: "simple",
								name: "",
								value: "",
								status: "default",
								error: false,
								errorMessage: "Неверный формат",
								categories: this.regions,
							},
						},
						{
							kind: "single",
							type: "dropdown",
							name: "city",
							title: "Населенный пункт",
							value: "",
							disabled: true,
							dropdown: {
								type: "simple",
								name: "",
								value: "",
								status: "default",
								error: false,
								errorMessage: "Неверный формат",
								categories: this.cities,
							},
						},
						{
							kind: "single",
							type: "dropdown",
							name: "street",
							title: "Улица",
							value: "",
							disabled: true,
							dropdown: {
								type: "simple",
								name: "",
								value: "",
								status: "default",
								error: false,
								errorMessage: "Неверный формат",
								categories: this.streets,
							},
						},
						{
							kind: "double",
							first: {
								type: "input",
								name: "home",
								title: "Дом",
								value: "",
								status: "default",
								error: false,
								errorMessage: "Неверный формат",
							},
							last: {
								type: "input",
								name: "apartment",
								title: "Квартира/помещение",
								value: null,
								status: "default",
								error: false,
								errorMessage: "Неверный формат",
							},
							status: "default",
						},
						{
							kind: "single",
							type: "input",
							name: "comment",
							title: "Комментарий",
							value: "",
							status: "default",
							error: false,
							errorMessage: "Неверный формат",
						},
					];
				}

				if (this.type == "pro_home") {
					this.lightbox.body = [
						{
							kind: "single",
							type: "input",
							name: "name",
							title: "Название объекта",
							value: "",
							status: "default",
							error: false,
							errorMessage: "Неверный формат",
						},
						{
							kind: "single",
							type: "dropdown",
							name: "dealer",
							title: "Дилер",
							value: "",
							dropdown: {
								type: "simple",
								name: "",
								value: "",
								status: "default",
								error: false,
								errorMessage: "Неверный формат",
								categories: this.dealers,
							},
						},
						{
							kind: "single",
							type: "dropdown",
							name: "pro_system_id",
							title: "Централизованная система",
							value: "",
							dropdown: {
								type: "simple",
								name: "",
								value: "",
								status: "default",
								error: false,
								errorMessage: "Неверный формат",
								categories: this.proSystems,
							},
						},
						{
							kind: "single",
							type: "dropdown",
							name: "region",
							title: "Регион",
							value: "",
							dropdown: {
								type: "simple",
								name: "",
								value: "",
								status: "default",
								error: false,
								errorMessage: "Неверный формат",
								categories: this.regions,
							},
						},
						{
							kind: "single",
							type: "dropdown",
							name: "city",
							title: "Населенный пункт",
							value: "",
							disabled: true,
							dropdown: {
								type: "simple",
								name: "",
								value: "",
								status: "default",
								error: false,
								errorMessage: "Неверный формат",
								categories: this.cities,
							},
						},
						{
							kind: "single",
							type: "dropdown",
							name: "street",
							title: "Улица",
							value: "",
							disabled: true,
							dropdown: {
								type: "simple",
								name: "",
								value: "",
								status: "default",
								error: false,
								errorMessage: "Неверный формат",
								categories: this.streets,
							},
						},
						{
							kind: "double",
							first: {
								type: "input",
								name: "home",
								title: "Дом",
								value: "",
								status: "default",
								error: false,
								errorMessage: "Неверный формат",
							},
							last: {
								type: "input",
								name: "apartment",
								title: "Квартира/помещение",
								value: null,
								status: "default",
								error: false,
								errorMessage: "Неверный формат",
							},
							status: "default",
						},
						{
							kind: "single",
							type: "input",
							name: "comment",
							title: "Комментарий",
							value: "",
							status: "default",
							error: false,
							errorMessage: "Неверный формат",
						},
					];
				}
			},

			/* SPECIAL HANDLERS */
			handleInputCommon(payload) {
				let input = this.lightbox.body.find((element) => element.name == payload.name);

				if (input) {
					input.value = payload.value;

					this.fields[input.name] = payload.value;

					if (payload.value.match(this.state.common.patterns[payload.name])) {
						input.status = "valid";
						input.error = false;
					} else {
						input.status = "invalid";
						input.error = true;
					}
				}
			},
			handleInputDouble(payload) {
				let inputFirst = this.lightbox.body.find(
					(element) => element.kind == "double" && element.first.name == payload.name
				);
				let inputLast = this.lightbox.body.find(
					(element) => element.kind == "double" && element.last.name == payload.name
				);

				if (inputFirst) {
					inputFirst.first.value = payload.value;
					this.fields[inputFirst.first.name] = payload.value;

					if (payload.value.match(this.state.common.patterns[payload.name])) {
						inputFirst.first.status = "valid";
						inputFirst.first.error = false;
					} else {
						inputFirst.first.status = "invalid";
						inputFirst.first.error = true;
					}
				} else if (inputLast) {
					inputLast.last.value = payload.value;
					this.fields[inputLast.last.name] = +payload.value;

					if (payload.value.match(this.state.common.patterns[payload.name])) {
						inputLast.last.status = "valid";
						inputLast.last.error = false;
					} else {
						inputLast.last.status = "invalid";
						inputLast.last.error = true;
					}
				}
			},

			handleDropdownCommon(payload) {
				let dropdown = this.lightbox.body.find((element) => element.name == payload.name);

				if (dropdown) {
					dropdown.dropdown.name = payload.value;
					dropdown.dropdown.value = payload.title;
					dropdown.dropdown.status = "valid";

					if (dropdown.name == "street") {
						if (payload.id == "absent") this.fields[dropdown.name] = null;
						else this.fields[dropdown.name] = +payload.id;
					} else this.fields[dropdown.name] = +payload.id;
				}
			},
			handleDropdownType(payload) {
				this.type = payload.value;
				this.preface.dropdown.value = payload.title;
				this.preface.dropdown.status = "valid";

				this.fields.type = payload.value;

				this.initLightboxBody();
			},
			handleDropdownRegions(payload) {
				let dropdown = this.lightbox.body.find((element) => element.name == payload.name);
				let citiItem = this.lightbox.body.find((item) => item.name == "city");
				let streetItem = this.lightbox.body.find((item) => item.name == "street");

				if (citiItem) {
					citiItem.disabled = true;
					citiItem.dropdown.value = "";
					citiItem.dropdown.status = "default";
				}

				if (streetItem) {
					streetItem.disabled = true;
					streetItem.dropdown.value = "";
					streetItem.dropdown.status = "default";
				}

				if (dropdown) {
					dropdown.dropdown.value = payload.title;
					dropdown.dropdown.status = "valid";

					this.fields[dropdown.name] = +payload.id;

					this.loading = true;

					axios
						.get(
							`${this.state.common.api}/geo-cities?filters[from_region][$eq]=${payload.id}`,
							this.state.common.headers
						)
						.then((response) => {
							this.loading = false;

							this.cities = response.data.data.map((item) => {
								let obj = {
									id: item.id,
									name: "city",
									title: item.name,
								};
								return obj;
							});

							if (citiItem) {
								citiItem.disabled = false;
								citiItem.dropdown.categories = this.cities;
							}
						})
						.catch((error) => {
							console.log(error);
							this.loading = false;
						});
				}
			},
			handleDropdownCities(payload) {
				let dropdown = this.lightbox.body.find((element) => element.name == payload.name);
				let streetItem = this.lightbox.body.find((item) => item.name == "street");

				if (streetItem) {
					streetItem.disabled = true;
					streetItem.dropdown.value = "";
					streetItem.dropdown.status = "default";
				}

				if (dropdown) {
					dropdown.dropdown.value = payload.title;
					dropdown.dropdown.status = "valid";

					this.fields[dropdown.name] = +payload.id;

					this.loading = true;

					axios
						.get(
							`${this.state.common.api}/geo-streets?filters[from_city][$eq]=${payload.id}`,
							this.state.common.headers
						)
						.then((response) => {
							this.loading = false;

							this.streets = response.data.data.map((item) => {
								let obj = {
									id: item.id,
									name: "street",
									title: item.name,
								};
								return obj;
							});

							if (streetItem) {
								streetItem.disabled = false;
								streetItem.dropdown.categories = this.streets;

								streetItem.dropdown.categories.push({
									id: "absent",
									name: "street",
									title: "Отсутствует в списке",
								});
							}
						})
						.catch((error) => {
							console.log(error);
							this.loading = false;
						});
				}
			},
			handleDropdownProSystem(payload) {
				let dropdown = this.lightbox.body.find((element) => element.name == payload.name);

				if (dropdown) {
					dropdown.dropdown.value = payload.title;
					dropdown.dropdown.status = "valid";

					this.fields[dropdown.name] = payload.id;
				}
			},
			checkValidation() {
				if (this.lightbox.body?.length) {
					const filtered = this.lightbox.body.filter((item) => item.name !== "comment");

					this.validation = filtered.every((element) => {
						if (element.kind == "single") {
							if (element.type == "input") return element.status == "valid";
							if (element.type == "dropdown") return element.dropdown.status == "valid";
						} else if (element.kind == "double") {
							if (element.first.type == "input" && element.last.type == "input") {
								return element.first.status == "valid" && element.last.status == "valid";
							}
						}
					});
				}
			},

			/* EVENT HANDLERS */
			onChange(event, source) {
				let payload = null;

				if (source === "input") {
					payload = {
						name: event.target.name,
						value: event.target.value,
						event: event.type,
					};

					if (payload.name == "home" || payload.name == "apartment") this.handleInputDouble(payload);
					else this.handleInputCommon(payload);
				}

				if (source === "dropdown") {
					if (event.target.closest(".dropdown__item")) {
						payload = {
							name: event.target.closest(".dropdown").getAttribute("name"),
							id: event.target.closest(".dropdown__item").getAttribute("data-id"),
							title: event.target.closest(".dropdown__item").querySelector(".dropdown__title").innerHTML,
							value: event.target.closest(".dropdown__item").getAttribute("data-name"),
						};

						if (payload.name == "type") this.handleDropdownType(payload);
						else if (payload.name == "region") this.handleDropdownRegions(payload);
						else if (payload.name == "city") this.handleDropdownCities(payload);
						else if (payload.name == "pro_system_id") this.handleDropdownProSystem(payload);
						else this.handleDropdownCommon(payload);
					}
				}

				if (event.type == "blur") {
					if (event.target.name == "comment") {
						const found = this.lightbox.body.find((item) => item.name == "comment");

						if (found && found.value == "") {
							found.status = "default";
						}
					}
				}
				this.checkValidation();
			},
			onCancel() {
				this.showLightboxObject(false);
				this.onReset();
			},
			onApply() {
				this.newCreateSystemsObject(this.fields);
				this.showLightboxObject(false);
				this.onReset();
			},
			onReset() {
				if (this.lightbox.body?.length) {
					this.lightbox.body.forEach((element) => {
						element.value = null;
						element.status = "default";
						element.error = false;
					});
				}

				this.preface.dropdown.value = "";
				this.preface.dropdown.status = "default";
				this.type = null;
				this.validation = false;
			},
		},
		mounted() {
			this.$bus.subscribe("lbxshow", this.init);
		},
		unmounted() {
			this.$bus.unsubscribe("lbxshow", this.init);
		},
		watch: {
			lightboxObjectVisible: function (newVal) {
				if (newVal) this.initLightbox();
			},
		},
	};
</script>

<style lang="scss" scoped></style>
